/**
 * @file
 * Provide behavior to change the donation value based on selected frequency.
 */

(function ($, Drupal) {
  Drupal.behaviors.donationFormValue = {
    attach: function attach(context) {

      function setDonationValues() {
        const amountRadios = $('#edit-donation-amount .checkbox');
        amountRadios.addClass('is-hidden-form-item-donation-amount');
        amountRadios.each(function( index ) {
          // Hide amounts, which should not be available for chosen frequency.
          let frequency = $('input:radio[name="donation_frequency"]:checked').val();
          if (!frequency) {
            // If no frequency is set, show options for one time donation.
            frequency = 'once';
          }
          const $input = $(this).find('.checkbox__input[data-frequencies]');
          // Determine allowed amounts by option frequency data.
          const frequencies = $input.attr('data-frequencies').split(',');
          if ($.inArray(frequency, frequencies) !== -1) {
            $(this).removeClass('is-hidden-form-item-donation-amount');
          }
        });
      }

      setDonationValues();

      // Handle change of donation frequency.
      $('#edit-donation-frequency input[type=radio]').change(function() {
        // We only want to handle the event if the radio is checked,
        // else we would run this code 5 times on page load
        // (because there are 5 frequency options).
        if (!$(this).is(':checked')) {
          return;
        }
        let frequency = $('input:radio[name="donation_frequency"]:checked').val();
        let amount_label = Drupal.t('Your donation amount');
        let $amount_active = $('input[name*="donation_amount"]:checked');
        frequency = frequency === 0 ? 1 : frequency;

        // Call setDonationValues() to show correct donation values
        setDonationValues();

        // Set wording of the amount label
        switch (frequency) {
          case '1':
            amount_label = Drupal.t('Your monthly donation amount');
            break;
          case '3':
            amount_label = Drupal.t('Your quarterly donation amount');
            break;
          case '6':
            amount_label = Drupal.t('Your semi-annual donation amount');
            break;
          case '12':
            amount_label = Drupal.t('Your annual donation amount');
            break;
        }

        $('#edit-donation-amount--wrapper .fieldset-legend').contents().replaceWith(amount_label + ' ');

        // Check, if the currently selected amount is hidden for the chosen frequency.
        // If not hidden, we can keep the selected amount.
        const amountIsHidden = $amount_active.parent().hasClass('is-hidden-form-item-donation-amount')
        if (!amountIsHidden) {
          return
        }
        // If the currently selected amount is hidden for the chosen frequency,
        // we need to uncheck the selected amount.
        if ($amount_active.length > 0 && $amount_active.val() !== 'free' && amountIsHidden) {
          $amount_active.get(0).checked = false;
        }
      });
    }
  };
})(jQuery, Drupal);
